import { Field } from "react-final-form";
import classNames from "classnames";
import getConfig from "next/config";

import Radio from "@components/Form/Radio";
import Alert from "@components/Alert";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const VehicleStateSection = ({ values }) => (
  <div className="space-y-[10px]">
    <div className="text-sm font-medium">
      Stare vehicul <span className="text-red-brand">*</span>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-[16px]">
      <div
        className={classNames("flex items-center p-[16px] bg-white", {
          "border border-[#99CE88]":
            Number(values.vehicle?.vehicleRegistrationStatus) === 1,
        })}
      >
        <Field
          name="vehicle.vehicleRegistrationStatus"
          type="radio"
          value="1"
          component={Radio}
          label="Inmatriculat"
          className="cursor-pointer w-full mb-0"
          labelClass="font-normal text-[14px]"
        />
      </div>

      <div
        className={classNames("flex items-center p-[16px] bg-white", {
          "border border-[#99CE88]":
            Number(values.vehicle?.vehicleRegistrationStatus) === 2,
        })}
      >
        <Field
          name="vehicle.vehicleRegistrationStatus"
          type="radio"
          value="2"
          component={Radio}
          label="In vederea inmatricularii"
          className="cursor-pointer w-full mb-0"
          labelClass="font-normal text-[14px]"
        />
      </div>
    </div>

    {Number(values.vehicle?.vehicleRegistrationStatus) === 2 && (
      <Alert type="warning" showIcon>
        <p className="text-[14px]">
          <strong>Atentie!</strong> Pentru emiterea politei RCA „in vederea
          inmatricularii”, este necesar sa trimiteti un document care atesta
          achizitia vehiculului (contract de vanzare-cumparare, factura sau alt
          document justificativ) la adresa:{" "}
          <strong>asigurari@{websiteName}.ro</strong>. Polita va fi emisa doar
          dupa verificarea documentelor.
        </p>
      </Alert>
    )}
  </div>
);

export default VehicleStateSection;
